<template>
  <div
    class="
      custom-group-tours-review-card
      pa-16 bg-white
      br-12
      bd-1 bd-gray-medium
      flex flex-column
      justify-between
    "
  >
    <div>
      <template v-if="!loading">
        <div class="review-info flex mb-8">
          <img class="w-40 mr-8" :src="icon" alt="quote icon" />
          <p class="fs-14 lh-18 mb-0">
            <span>{{ country }}</span>
            <br />
            <span>{{ formatDate(date, 'm d Y') }}</span>
          </p>
        </div>
        <div
          class="dwb content fs-16 lh-24 ellipsis overflow-hidden mb-20"
          v-html="content"
        ></div>
      </template>
      <template v-else>
        <div class="flex grid-gap-8 mb-8">
          <SkeletonLoading
            width="36px"
            height="36px"
            class="pa-4"
            borderRadius="50%"
          />
          <div class="flex flex-column grid-gap-4">
            <SkeletonLoading width="50px" height="16px" />
            <SkeletonLoading width="100px" height="16px" />
          </div>
        </div>
        <div>
          <SkeletonLoading
            v-for="item in 5"
            :key="item"
            class="mb-4"
            height="24px"
          />
        </div>
      </template>
    </div>
    <div>
      <template v-if="!loading">
        <div class="review-traveller bd-t-1 bd-gray-medium pt-8 flex">
          <img
            class="w-40 h-40 br-p-50 mr-8"
            width="40"
            height="40"
            :src="image"
            alt="user picture"
          />
          <div class="text">
            <p class="fs-16 fw-600 lh-24 mb-0">{{ travellerName }}</p>
            <p class="fs-14 fw-500 lh-18 gray-dark mb-0">{{ travellerType }}</p>
          </div>
        </div>
        <div class="more-info flex items-center justify-between h-40">
          <div class="rating h-fit-content">
            <span class="mr-4" v-for="item in Math.floor(rating)" :key="item">
              <img
                :src="`${ASSETS_CDN}/icons/icon-rating.svg`"
                alt="rating-icon"
              />
            </span>
            <span class="mr-4" v-if="rating % 1"
              ><img
                :src="`${ASSETS_CDN}/icons/icon-rating-half.svg`"
                alt=""
                srcset=""
              />
            </span>
            <span v-for="item in grayLength" :key="item" class="mr-4">
              <img
                :src="`${ASSETS_CDN}/icons/icon-rating-gray.svg`"
                alt="rating-gray-icon"
              />
            </span>
          </div>
          <div class="read-more flex items-center" v-if='link'>
            <a
              :href="`/local-designer/${link}#reviews`"
              class="
                fs-16
                lh-24
                fw-500
                pa-8
                pr-0
                mr-4
                items-center
                justify-center
              "
              target="_blank"
            >
              <span class="blue-dark"> Read more </span>
            </a>
            <img
              :src="`${ASSETS_CDN}/icons/arrow_forward.svg`"
              alt="arrow_forward"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="bd-t-1 bd-gray-medium pt-8 flex grid-gap-8">
          <SkeletonLoading width="40px" height="40px" borderRadius="50%" />
          <div class="flex flex-column grid-gap-4">
            <SkeletonLoading width="50px" height="16px" />
            <SkeletonLoading width="100px" height="16px" />
          </div>
        </div>
        <div class="flex justify-between mt-8">
          <SkeletonLoading height="24px" />
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { formatDate,assetCDN } from '~/helper'
import SkeletonLoading from '~/components/globals/Loading/SkeletonLoading'

const ASSETS_CDN = assetCDN()
const props = defineProps({
  icon: {
    type: String,
    default: () => `${assetCDN()}/icons/quoteupcircle.svg`,
  },
  country: {
    type: String,
    default: 'Italy',
  },
  date: {
    type: String,
    default: 'May 25, 2023',
  },
  content: {
    type: String,
    default: `Upon arrival, my personal guide greeted me warmly and showed a deep understanding of both local culture and impeccable style. Designer Journey had curated a tailor-made itinerary that allowed me to connect with local designers and immerse myself in the world of creativity.
    Throughout the trip, I had the opportunity to meet talented designers and visit their studios, gaining insight into their unique creations. Designer Journey's selection of locations showcased a diverse range of design experiences, from buzzing fashion districts to hidden gems in cozy neighborhoods.`,
  },
  rating: {
    type: String,
    default: '4.5',
  },
  travellerName: {
    type: String,
    default: 'Sean and Merle R.',
  },
  travellerType: {
    type: String,
    default: 'Traveller',
  },
  image: {
    type: String,
    default: () => `${assetCDN()}/images/customgrouptour/User_01.png`,
  },
  link: {
    type: String,
    default: '',
  },
  loading: {
    type: Boolean,
    default: false,
  },
})
const grayLength = computed(() => Math.floor(5 - props.rating))
</script>

<style lang="scss" scoped>
.custom-group-tours-review-card {
  flex: 0 0 343px;
  min-height: 360px;
  .content {
    -webkit-line-clamp: 7;
    -webkit-box-orient: vertical;
    white-space: pre-wrap;
  }

  @include phone() {
    flex: 0 0 320px;
  }
}
</style>
